export default (code: string): string => {
    switch (code) {
        case 'fr':
            return 'frFR';
        case 'en':
            return 'enUS';
        default:
            return 'frFR';
    }
};